module.exports = __webpack_public_path__ + "static/media/UNCTAD_AWARD.529ba3ad.jpg";